export default "__VITE_ASSET__CYS2ZRKg__"